// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.7.6_@swc+helpers@0.5.23__webpack@5.109.0_@swc+core@1.9._a8730cba2a73adfdb4d71cf9e1e7c3f7/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_@rspack+core@1.7.6_@swc+helpers@0.5.23__webpack@5.109.0_@swc+core@1.9._a8730cba2a73adfdb4d71cf9e1e7c3f7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Improve font rendering.
 */
body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

/**
 * Enable momentum scrolling on touch devices.
 */
.overflow-auto,
.overflow-x-auto,
.overflow-y-auto {
  -webkit-overflow-scrolling: touch;
}

/**
 * Allow only vertical resizing of textareas.
 */
textarea {
  resize: vertical;
}

/**
 * Remove the gap between these elements and the bottom of their containers.
 * See: https://github.com/h5bp/html5-boilerplate/issues/440
 */
svg,
img,
canvas,
video,
audio,
iframe {
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/reset.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;EAEE;AACF;;;EAGE,iCAAiC;AACnC;;AAEA;;EAEE;AACF;EACE,gBAAgB;AAClB;;AAEA;;;EAGE;AACF;;;;;;EAME,sBAAsB;AACxB","sourcesContent":["/**\n * Improve font rendering.\n */\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\n/**\n * Enable momentum scrolling on touch devices.\n */\n.overflow-auto,\n.overflow-x-auto,\n.overflow-y-auto {\n  -webkit-overflow-scrolling: touch;\n}\n\n/**\n * Allow only vertical resizing of textareas.\n */\ntextarea {\n  resize: vertical;\n}\n\n/**\n * Remove the gap between these elements and the bottom of their containers.\n * See: https://github.com/h5bp/html5-boilerplate/issues/440\n */\nsvg,\nimg,\ncanvas,\nvideo,\naudio,\niframe {\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
